import styled from 'styled-components';

export const Divider = styled.div`
  width: 1px;
  height: 25px;
  background: var(--cc_color_border_default);
  margin-left: var(--cc_size_spacing_xs);
  margin-right: var(--cc_size_spacing_xs);
`;
